// import { useTranslation } from 'react-i18next';
import { t } from 'i18next';

import { FieldVisibility, TablePropertyFields } from 'src/constants/dataTypes';

export const getDefaultInvoiceColumnSettings = (): TablePropertyFields => ({
  tablePropertyFields: [
    {
      id: 'client',
      name: 'Recipient',
      disabled: false,
    },
    {
      id: 'amount',
      name: 'Amount',
      disabled: false,
    },
    {
      id: 'status',
      name: 'Status',
      disabled: false,
    },
    {
      id: 'invoiceNumber',
      name: 'Invoice number',
      disabled: false,
    },
    {
      id: 'created',
      name: 'Created',
      disabled: false,
    },
    {
      id: 'due',
      name: 'Due',
      disabled: false,
    },
    {
      id: 'paymentDate',
      name: 'Payment',
      disabled: false,
    },
    {
      id: 'type',
      name: 'Type',
      disabled: true,
    },
    {
      id: 'paymentFee',
      name: 'Payment fees',
      disabled: true,
    },
    {
      id: 'clientPaymentFee',
      name: t(($) => $.page_billing.client_payment_fees),
      disabled: true,
    },
    {
      id: 'currency',
      name: 'Currency',
      disabled: true,
    },
    {
      id: 'memo',
      name: 'Memo',
      disabled: true,
    },
    {
      id: 'taxPercentage',
      name: 'Tax percent',
      disabled: true,
    },
  ] as FieldVisibility[],
});
